import { TerritoryFiltersControl } from "app/pages/sales-intelligence/modules/teams/components/TerritoryFiltersControl";

import { useIsTerritoryEligible } from "../../hooks/useIsTerritoryEligible";

/**
 * Page-level gate that owns the route/feature eligibility for the "My territory filters" control.
 * Renders the (page-agnostic) {@link TerritoryFiltersControl} only when territory is eligible, so the
 * module component never has to know which page it runs on. A URL seed does not hide the control — it
 * only leaves the toggle off (see `useApplyTerritoryFilters`), so the user can still opt in.
 */
export const TerritoryFiltersControlGate = () => {
    const isTerritoryEligible = useIsTerritoryEligible();

    if (!isTerritoryEligible) {
        return null;
    }

    return <TerritoryFiltersControl />;
};
